// Third-party
import React from 'react';

// Components
import { HoldingIcon } from '../../common';

// Utils
import { formatMessageWithLocale, FormattedMessage, formatLocalizedString } from '../../../../utils/i18n';
import { enumerateJSX, truncateString } from '../../../../utils/objects';
import { FUND_SOURCE } from '../../../../utils/constants';
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';

interface Props {
  items: ComparisonItem[];
  showItemNames: boolean;
  locale?: Locale;
}

const FundataMERDisclaimer = ({ items, showItemNames = true, locale }: Props) => {
  const fundataItems = items.filter(item => item.mer != null && item.trustedSource === FUND_SOURCE.FUNDATA);

  return (
    <>
      {fundataItems.length > 0 && (
        <span className="disclaimer">
          <FormattedMessage id={showItemNames ? 'Disclaimers.FundataMERs' : 'Disclaimers.FundataMER'} locale={locale} />

          {showItemNames &&
            enumerateJSX(
              fundataItems.map(item => (
                <span key={item._id}>
                  <HoldingIcon type={item.type} color={item.color} />
                  {truncateString(formatLocalizedString(item.name, locale), 20)}
                </span>
              )),
              formatMessageWithLocale('Common.And', locale),
            )}
        </span>
      )}
    </>
  );
};

export default FundataMERDisclaimer;
